export const REACT_APP_LANDING_PAGE = process.env.REACT_APP_LANDING_PAGE || '';
export const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL || '';
export const REACT_APP_ENV = process.env.REACT_APP_ENV || '';
export const REACT_APP_AMWAYNOW = process.env.REACT_APP_AMWAYNOW || '';
export const REACT_CACHE_TIME = process.env.REACT_CACHE_TIME || '100000';

// Microsoft Entra admin
export const ENTRA_AUTHORIZE_BASE_URL = process.env.REACT_APP_AUTHORIZE_BASE_URL || '';
export const AUTH_ADMIN_CLIENT_IDS = process.env.REACT_APP_AUTH_ADMIN_CLIENT_IDS || '';
export const AUTH_ADMIN_REDIRECT_URIS =
  `${window.location.protocol}//${window.location.host}` + process.env.REACT_APP_ADMIN_REDIRECT || '';
//export const AUTH_ADMIN_SERVER_ID = process.env.REACT_APP_AUTH_ADMIN_SERVER_ID || '';
export const ENTRA_TENANT_ID = process.env.REACT_APP_AUTH_ADMIN_TENANT_ID || '';

// AmwayId
export const REACT_APP_AMWAYID_AUTHORIZE_BASE_URL = process.env.REACT_APP_AMWAYID_AUTHORIZE_BASE_URL || '';
export const REACT_APP_AMWAYID_SERVER_ID = process.env.REACT_APP_AMWAYID_SERVER_ID || '';
export const REACT_APP_AMWAYID_CLIENT_ID = process.env.REACT_APP_AMWAYID_CLIENT_ID || '';
export const REACT_APP_AMWAYID_CLIENT_APP = process.env.REACT_APP_AMWAYID_CLIENT_APP || '';
export const REACT_APP_AMWAYID_REDIRECT_URI =
  `${window.location.protocol}//${window.location.host}` + process.env.REACT_APP_AMWAYID_REDIRECT || '';
export const REACT_APP_AMWAY_REDIRECT_LOG_OUT_URI = `${window.location.protocol}//${window.location.host}` || '';
